import { RestartAltSharp } from '@mui/icons-material/'
import { Button, Typography, Stack, Paper, Box } from '@mui/material'
// import Grid2 from '@mui/material/Unstable_Grid2/Grid2'
import React from 'react'
// import { useTheme } from '@mui/system'
import appUtilities from '../utilities/appUtilities.js'
import { TitleImage } from '../styles/titleImageStyle'
import { useMediaQuery } from '@mui/material'
import theme from '../styles/theme'
export default function TitleRow({ handlePgNav, titleText, bomGrid }) {
    // const theme = useTheme()

    // const valueMarginBot = bomGrid ? 2 : 0
    // const sxPropPaper = { px: { xs: 0.25, sm: 2 }, py: 2 }
    // const sxPropPaper = { px: { xs: 0.25, sm: 2 }, py: 2 }

    //  bomGrid
    //     ? { mt: { xs: 0.4, sm: 1.4 }, mb: 0 }
    //     : { mt: { xs: 0, sm: 1.4 }, mb: 2 }
    // const md = useMediaQuery(theme.breakpoints.down('md'))
    const sm = useMediaQuery(theme.breakpoints.down('sm'))
    const sxProp = {
        maxHeight: sm ? '48px' : '72px',
        mt: 1,
        mb: bomGrid ? 2 : 1.5,
        px: 0,
    }
    const varProp = sm ? 'subtitle1' : 'h6'

    const logopath = sm ? '/calc/logo_sm2.png' : '/calc/logo_sm.png'
    return (
        <Stack direction={'row'} justifyContent={'space-between'} flex="1">
            <Box flex="1">
                <Paper
                    elevation={0}
                    sx={{ p: 2, px: { xs: 1, sm: 2 }, mr: '4px', pr: '0px' }}
                >
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{
                            pl: { xs: 0.5 },
                            pr: { xs: 0.5 },
                            '& .MuiButton-endIcon': {
                                // At ≤365px → zero margin
                                '@media (min-width: 0px) and (max-width: 365px)':
                                    {
                                        marginLeft: 0,
                                    },
                            },

                            '@media (min-width: 0px) and (max-width: 365px)': {
                                fontSize: '0.65rem',
                            },
                        }}
                        onClick={() =>
                            handlePgNav(appUtilities.navDirections.reset)
                        }
                        endIcon={<RestartAltSharp />}
                    >
                        Restart
                    </Button>
                </Paper>
            </Box>
            <Stack
                direction="row"
                // sx={{ my: 1 }}
                flex="1"
                justifyContent={'center'}
                // marginRight={2}
            >
                <Paper elevation={4} sx={sxProp}>
                    <TitleImage src={logopath} theme />
                </Paper>
            </Stack>
            <Box flex="1" sx={{ display: 'inline-block' }}>
                <Paper
                    elevation={0}
                    sx={{ p: 2, px: { xs: 1, sm: 2 }, ml: '4px', pl: '0px' }}
                >
                    <Typography
                        align="right"
                        variant={varProp}
                        // paddingRight={'2'}

                        sx={{
                            verticalAlign: 'bottom',

                            fontSize: {
                                xs: '0.9rem', // mobile
                                sm: '1.4rem', // tablet
                                md: '1.6rem', // desktop
                            },

                            '@media (min-width: 420px) and (max-width: 599px)':
                                {
                                    fontSize: '1.1rem',
                                },

                            mt: { xs: 0, sm: 0.6 },
                            fontWeight: 500,
                            lineHeight: { xs: 1.3, sm: 1.75 },
                        }}
                    >
                        {titleText}
                    </Typography>
                </Paper>
            </Box>
        </Stack>
    )
}
